import { postLogger } from "../services/loggerApi";
import * as StorageUtils from "./storageUtils";
import { APP_USER_SESSION } from "../constant/AppConstants";

const SOURCE = "MCP-MERCHANT-DASHBOARD";

const userSession = StorageUtils.getParsedValue(APP_USER_SESSION)
  ? StorageUtils.getParsedValue(APP_USER_SESSION)
  : "";

export const Logger = {
  writeLog(
    message,
    email = userSession.user ? userSession.user.email : "",
    level = "info"
  ) {
    const query = {
      message: `{${SOURCE}}:{${email} ${message}}`,
      level: LogType[level],
    };
  },
};

const LogType = {
  info: "INFO",
  error: "ERROR",
  warn: "WARN",
  debug: "DEBUG",
  trace: "TRACE",
  fatal: "FATAL",
};
